
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz'
import { types } from 'mobx-state-tree'
import MultiToggle from '@/components/MultiToggle'

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h2" components={components} props={{"id":"multitoggle-component"}}>{`MultiToggle Component`}</MDXTag>
<Playground __position={0} __code={'<MultiToggle\n  options={[\n    { display: \'A-Z\', value: [\'alpha\', \'asc\'] },\n    { display: \'Z-A\', value: [\'alpha\', \'desc\'] },\n    { display: \'0-9\', value: [\'numeric\', \'asc\'] },\n    { display: \'9-0\', value: [\'numeric\', \'dec\'] },\n    { display: \'🚫\', value: \'disabled\' },\n  ]}\n/>'} __scope={{props: this ? this.props : props,types,MultiToggle}}>
  <MultiToggle
    options={[
      { display: 'A-Z', value: ['alpha', 'asc'] },
      { display: 'Z-A', value: ['alpha', 'desc'] },
      { display: '0-9', value: ['numeric', 'asc'] },
      { display: '9-0', value: ['numeric', 'dec'] },
      { display: '🚫', value: 'disabled' },
    ]}
  />
</Playground>
           </MDXTag>
  }
}
  